import { render } from "./ProductModifierItem.vue?vue&type=template&id=2587001c&scoped=true&ts=true"
import script from "./ProductModifierItem.vue?vue&type=script&lang=ts"
export * from "./ProductModifierItem.vue?vue&type=script&lang=ts"

import "./ProductModifierItem.vue?vue&type=style&index=0&id=2587001c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2587001c"]])

export default __exports__